const loggedIn = (user) => user !== null && user !== undefined;
export default loggedIn;
